
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipment/[category]",
      function () {
        return require("private-next-pages/equipment/[category].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipment/[category]"])
      });
    }
  